"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { LuaCostMonthlyProps } from "./LuaCostMonthlyChart.impl";

export const LuaCostMonthlyChart = dynamicChart(
  () => import("./LuaCostMonthlyChart.impl").then((m) => m.LuaCostMonthlyChart),
  340,
);
